export default [
  {
    path: "/cash",
    name: "Cashier",
    component: () => import("../../view/Cashier/index.vue"),
    meta: {
      // 判断此页是否需要登录
      requireAuth: true,
    },
    redirect: "/cash/index",
    children: [
      {
        path: "login",
        name: "cashlogin",
        component: () => import("../../view/Cashier/login.vue"),
      },
      {
        path: "index",
        name: "cashindex",
        component: () => import("../../view/Cashier/view/cashier.vue"),
      },
      {
        path: "product",
        name: "cashproduct",
        component: () => import("../../view/Cashier/view/product.vue"),
      },
      {
        path: "order",
        name: "cashorder",
        component: () => import("../../view/Cashier/view/order.vue"),
      },
      {
        path: "handover",
        name: "cashandover",
        component: () => import("../../view/Cashier/view/handover.vue"),
      },
      {
        path: "setup",
        name: "cashsetup",
        component: () => import("../../view/Cashier/view/setup.vue"),
        redirect: "/cash/setup/shop",
        children: [
          {
            path: "shop",
            name: "setupshop",
            component: () =>
              import("../../view/Cashier/view/SetupView/shop.vue"),
          },
          {
            path: "staff",
            name: "setupstaff",
            component: () =>
              import("../../view/Cashier/view/SetupView/staff.vue"),
          },
          {
            path: "printer",
            name: "setuprinter",
            component: () =>
              import("../../view/Cashier/view/SetupView/printer.vue"),
          },
          {
            path: "ticket",
            name: "setupticket",
            component: () =>
              import("../../view/Cashier/view/SetupView/ticket.vue"),
          },
          {
            path: "journal",
            name: "setupjournal",
            component: () =>
              import("../../view/Cashier/view/SetupView/journal.vue"),
          },
          {
            path: "about",
            name: "setupabout",
            component: () =>
              import("../../view/Cashier/view/SetupView/about.vue"),
          },
        ],
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/router/modules/cash.js